export default function ({ store }) {
  store.commit('contentWithHeader/updateField', {path: 'isScrolledDown', value: false})
}